import { render } from "./UpdateNetwork.vue?vue&type=template&id=21ba67f8&scoped=true"
import script from "./UpdateNetwork.vue?vue&type=script&lang=js"
export * from "./UpdateNetwork.vue?vue&type=script&lang=js"

import "./UpdateNetwork.vue?vue&type=style&index=0&id=21ba67f8&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ba67f8"]])

export default __exports__